import React, { useEffect, useRef, useState } from 'react';
import { View } from "@/views/component/nav/style";
import { useMobx } from "@/utils/hooks";
import { useMemoizedFn } from "ahooks";
import { Modal } from "@/views/component/modal";
import { EModal } from "@/interface/enum";
import { observer } from "mobx-react-lite";
import { login, logout } from '@/utils/util';

function Index() {
  const store = useMobx('store');
  const suid = useRef('');
  const [checkbox, triggerCheckBox] = useState(false);

  const init = () => {
    initSuid();
    initSubscribed();
  }
  const initSuid = () => {
    const { QD: [QD], AW: [AW], hd } = store.urlParams;
    const _suid = CONFIG.subscribed[QD][AW].suid;
    suid.current = _suid;
  }
  const initSubscribed = () => {
    f2eGame.port.subscribe.isSubscribe({
      id: suid.current
    }).then((flag: boolean) => {
      triggerCheckBox(!!flag);
    });
  }

  useEffect(() => {
    init();
  }, [])

  const handleSubscribed = useMemoizedFn(() => {
    const newFlag = !checkbox;
    f2eGame.port.subscribe.confirmSubscribe({
      id: suid.current, // 订阅 ID
      confirm: newFlag // 订阅 取消订阅
    }).then((bool: boolean) => {
      if (bool) {
        triggerCheckBox(newFlag);
        alert(newFlag ? '订阅成功！' : '取消成功！');
      }
    })
  });
  const handleRecord = useMemoizedFn(() => {
    const postData = {
      type: 2,
      params: [
        `//task3game.yy.com/play/mixPackage.do`,
        {
          dataType: 'jsonp',
          data: {
            act: `${CONFIG.code.YYVIP2023_free_01},${CONFIG.code.act_dayRechargeTask},${CONFIG.code.act_weekIntegral},${CONFIG.code.YYVIP2022_free_exchange}`,
            pageId: 0,
            pageSize: 999
          }
        }
      ]
    };
    $refPopup.current.open(<Modal
      modalType={EModal['领取记录']}
      other={postData}
    />);
  })

  return <View>
    <div className="content">
      <a href={CONFIG.navbar.vipSite} target='_blank'>
        <img src="//img-game.yy.com/f2e/static/activity/new-yy-vip/may-day/images/logo-vip.png" alt=""/>
      </a>
      <a href={CONFIG.navbar.yygameSite} target='_blank'>
        <img src="//img-game.yy.com/f2e/static/activity/new-yy-vip/may-day/images/logo-yy.png" alt=""/>
      </a>
      <div>
        {store.isLogin !== undefined && <>
          {store.isLogin && <p className='login'>
            欢迎您，
            <span>{store.userInfo?.nickName}</span>
            {store.isBrowser && <span onClick={() => logout()}>[注销]</span>}
          </p>}
          {!store.isLogin && <p className='noLogin'>
            您好，
            <span onClick={() => login()}>请登录</span>
          </p>}
        </>}
        <div onClick={handleRecord}>领取记录</div>
        <label>
          <input checked={checkbox} onChange={handleSubscribed} type="checkbox"/>
          活动订阅
        </label>
      </div>
    </div>
  </View>
}

export default observer(Index);
